import Link from 'next/link';
import { useMemo } from 'react';

import { useUser } from 'context/user';
import { ContractorRoutes } from 'routes';
import { useNavigation } from './NavigationContext';
import { NavItem } from './types';

interface MainNavItemProps {
  item: NavItem;
  index: number;
}

export const MainNavItem: React.FC<MainNavItemProps> = ({ item, index }) => {
  const { activeMainNav, setActiveMainNav } = useNavigation();
  const { roleType, currentCompany } = useUser();
  const isWorker = roleType === 'worker';

  const isActive = activeMainNav === index;
  const defaultRoute = item.subNavs ? item.subNavs[0].href : item.href;

  const itemHref = useMemo(() => {
    if (defaultRoute === ContractorRoutes.EmployerProfile) {
      return ContractorRoutes.EmployerProfile.replace('[companyID]', currentCompany?.w2Payroll?.checkId);
    } else {
      return defaultRoute;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRoute]);

  const isComingSoon = defaultRoute === '/finance' || (isWorker && defaultRoute === '/apps');

  if (item.showInMainNav === false) {
    return null;
  }

  const handleClick = () => {
    setActiveMainNav(index);
  };

  return (
    <li key={item.name} className={`main-nav-item flex-1 lg:flex-none ${isComingSoon ? 'hidden md:flex' : ''}`}>
      <Link href={isComingSoon ? '#' : itemHref}>
        <span
          onClick={() => {
            !isComingSoon && handleClick();
          }}
          className={`relative flex h-16 flex-col items-center justify-center rounded-md border px-3 py-3 md:h-auto md:flex-row md:justify-start md:py-2 ${
            isActive
              ? 'border-neutral-200 bg-neutral-50 text-neutral-800'
              : 'border-transparent text-neutral-500 md:text-neutral-800'
          } ${isComingSoon ? 'disabled cursor-not-allowed' : 'hover:border-neutral-200'}`}
        >
          {/* Icons draw with currentColor; light keeps the original #404040 stroke gray
              while dark separates the states (white active, muted gray inactive). */}
          <span
            className={`main-nav-item-icon text-neutral-700 ${isActive ? 'dark:text-neutral-50' : 'dark:text-neutral-400'}`}
          >
            {item.icon}
          </span>
          <span className="ml-0 mt-0.5 text-xs font-medium md:ml-2 md:mt-0 md:text-sm">{item.name}</span>
          {isComingSoon && (
            <span className="absolute -top-1 left-10 ml-4 hidden w-fit min-w-[50px] rounded border border-neutral-200 bg-neutral-50 px-1 py-0.5 text-[6px] font-medium text-neutral-600 md:block">
              Coming Soon
            </span>
          )}
          {(item.name === 'Analyst' || item.name === 'Analytics') && (
            <span className="absolute -right-2 -top-2 rounded-full bg-therablue px-1 py-[2px] text-[9px] font-medium text-white">
              BETA
            </span>
          )}
        </span>
      </Link>
    </li>
  );
};
